// extracted by mini-css-extract-plugin
export default {"error":"gamePage_error__8pQO0"};